import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { getAuth0RedirectUri } from './utilities';
import { Store } from '@ngrx/store';
import { AuthService } from '@auth0/auth0-angular';
import {
  selectAccountID,
  selectAccountName,
  selectGMClientApiKey,
} from '../store/global/core-selectors';
import { Auth0User } from '../models/auth0User';

/**
 * Used for authentication and other general settings set during login, e.g. language.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  /**
   * @deprecated - can use the ngrx selector directly if consumer has store access
   */
  public user$: Observable<Auth0User> = this.auth0Service.user$ as Observable<Auth0User>;

  /**
   * @deprecated - can use the ngrx selector directly if consumer has store access
   */
  public mapsApiKey$ = this.store.select(selectGMClientApiKey);

  public get isAuthenticated$(): Observable<boolean> {
    return this.auth0Service.isAuthenticated$;
  }

  public get auth0error$(): Observable<Error> {
    return this.auth0Service.error$;
  }

  /**
   * Returns an observable that emits the current user's BLS account ID once available.
   */
  public get deferredBlsAccountId$(): Observable<number> {
    return this.store.select(selectAccountID).pipe(
        // Hold on until we have a value, otherwise calls that depend on this value will fail!
        filter(accountId => !!accountId),
        take(1));
  }

  /**
   * Returns an observable that emits the current user's BLS account name once available.
   */
  public get deferredBlsAccountName$(): Observable<string> {
    return this.store.select(selectAccountName).pipe(
        // hold on until we have a value, otherwise calls that depend on this value will fail!
        filter(accountName => !!accountName),
        take(1));
  }


  constructor(
      private store: Store,
      private auth0Service: AuthService,
  ) {
  }

  /**
   * Logs out the user and deletes all items from the local storage and the cookie. Redirects the user back to the login
   * page.
   */
  logout() {
    this.auth0Service.logout({
      logoutParams: {
        // needs to be specified since there are several whitelisted logout URIs in the auth0 dash
        // https://developer.auth0.com/resources/guides/spa/angular/basic-authentication
        returnTo: getAuth0RedirectUri(),
      },
    });
  }

  loginWithRedirect() {
    this.auth0Service.loginWithRedirect();
  }

}
